module.exports = __webpack_public_path__ + "img/fa-duotone-900.c0720e45.svg";